(() => {
  const config = window.themePerformance || {};
  const assets = config.assets || {};
  const loadedScripts = new Map();
  const loadedStyles = new Map();

  function loadScript(url) {
    if (!url) return Promise.resolve();
    if (loadedScripts.has(url)) return loadedScripts.get(url);

    const existing = document.querySelector(`script[src="${url}"]`);
    if (existing) {
      const done = Promise.resolve(existing);
      loadedScripts.set(url, done);
      return done;
    }

    const promise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.defer = true;
      script.onload = () => resolve(script);
      script.onerror = reject;
      document.head.appendChild(script);
    });

    loadedScripts.set(url, promise);
    return promise;
  }

  function loadStyle(url) {
    if (!url) return Promise.resolve();
    if (loadedStyles.has(url)) return loadedStyles.get(url);

    const existing = document.querySelector(`link[rel="stylesheet"][href="${url}"], link[data-dynamic-style="${url}"]`);
    if (existing) {
      const done = Promise.resolve(existing);
      loadedStyles.set(url, done);
      return done;
    }

    const promise = new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      link.dataset.dynamicStyle = url;
      link.onload = () => resolve(link);
      link.onerror = reject;
      document.head.appendChild(link);
    });

    loadedStyles.set(url, promise);
    return promise;
  }

  function whenIdle(callback, timeout = 1200) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout });
      return;
    }
    window.setTimeout(callback, 1);
  }

  function onFirstInteraction(selector, callback) {
    if (!selector) return;

    const handler = (event) => {
      if (!event.target.closest(selector)) return;
      cleanup();
      callback(event);
    };

    const cleanup = () => {
      document.removeEventListener('pointerdown', handler, true);
      document.removeEventListener('focusin', handler, true);
      document.removeEventListener('touchstart', handler, true);
      document.removeEventListener('mouseover', handler, true);
    };

    document.addEventListener('pointerdown', handler, true);
    document.addEventListener('focusin', handler, true);
    document.addEventListener('touchstart', handler, true);
    document.addEventListener('mouseover', handler, true);
  }

  function normalizeSidebarTriggers() {
    const selectors = ['a[data-cart-sidebar]', 'a[data-sidebar]'];
    document.querySelectorAll(selectors.join(',')).forEach((anchor) => {
      if (anchor.dataset.triggerNormalized === 'true') return;
      anchor.dataset.triggerNormalized = 'true';

      const href = anchor.getAttribute('href');
      if (href) {
        anchor.dataset.originalHref = href;
        anchor.removeAttribute('href');
      }

      anchor.setAttribute('role', 'button');
      if (!anchor.hasAttribute('tabindex')) {
        anchor.setAttribute('tabindex', '0');
      }
    });

    document.addEventListener('keydown', (event) => {
      const trigger = event.target.closest('a[data-cart-sidebar], a[data-sidebar]');
      if (!trigger) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      trigger.click();
    });
  }

  function loadPredictiveSearch() {
    if (!config.quickSearchEnabled) return;
    loadStyle(assets.predictiveSearchCss);
    loadScript(assets.predictiveSearchJs);
  }

  function loadQuickCartStyles() {
    const cartSidebar = document.getElementById('halo-cart-sidebar');
    const addToCartPopup = document.getElementById('halo-add-to-cart-popup');

    if (assets.quickCartMinCss) loadStyle(assets.quickCartMinCss);
    loadStyle(cartSidebar?.dataset.quickCartStyle || assets.quickCartCss);
    loadStyle(addToCartPopup?.dataset.quickCartStyle || assets.quickCartCss);
    loadStyle(addToCartPopup?.dataset.addToCartStyle || assets.addToCartCss);
  }

  function loadQuickCartScripts() {
    const cartSidebar = document.getElementById('halo-cart-sidebar');
    loadScript(cartSidebar?.dataset.quickCartScript || assets.quickCartScript);
  }

  function loadQuickShopOption3() {
    if (config.quickShopType !== '3') return;
    const popup = document.getElementById('halo-quickshop-popup-option-3');
    loadScript(popup?.dataset.quickShopScript || assets.quickShopOption3Js);
  }

  function loadGalleryExtras() {
    loadScript(assets.galleryExtrasJs);
  }

  if (config.pageType === 'product') {
    whenIdle(() => {
      loadScript(assets.productExtrasJs);
      loadScript(assets.haloUpsellCartJs);
    });
  }

  if (config.pageType === 'collection' || config.pageType === 'search') {
    whenIdle(() => loadScript(assets.collectionExtrasJs));
  }

  if (config.mobileMenuType === 'custom' || document.getElementById('navigation-mobile')) {
    whenIdle(() => loadScript(assets.menuGesturesJs));
  }

  normalizeSidebarTriggers();

  if (config.quickSearchEnabled) {
    onFirstInteraction(
      [
        '[data-search-mobile]',
        '[data-search-menu]',
        '[data-search-menu-sticky-form]',
        '#Search-In-Modal',
        '#Search-In-Modal-Sidebar',
        '[type="search"]'
      ].join(','),
      loadPredictiveSearch
    );
  }

  if (config.quickCartEnabled) {
    onFirstInteraction(
      [
        '[data-cart-sidebar]',
        '[name="add"]',
        '[data-quickshop-popup]',
        '#product-quick-shop-add-to-cart',
        '.button-ATC'
      ].join(','),
      loadQuickCartStyles
    );

    onFirstInteraction('[data-cart-sidebar]', loadQuickCartScripts);
  }

  if (config.quickShopType === '3') {
    onFirstInteraction('[data-quickshop-popup], [data-quickshop-popup-option-3]', loadQuickShopOption3);
  }

  if (config.quickViewEnabled || config.pageType === 'product') {
    onFirstInteraction(
      [
        '[data-open-quick-view-popup]',
        '[data-fancybox="product"]',
        '.productView-iconZoom'
      ].join(','),
      loadGalleryExtras
    );
  }

  window.themeAssetLoader = {
    loadScript,
    loadStyle
  };
})();
